import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.watchlist/v2/watchlists", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkCheck(arg0, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.watchlist/v2/watchlists/bulk-check", arg0, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateEntries(arg0, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.watchlist/v2/watchlists/validate-entries", arg0, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.watchlist/v2/watchlists/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEntries(id, arg1, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.watchlist/v2/watchlists/${id}/entries`, arg1, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listEntries(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.watchlist/v2/watchlists/${id}/entries`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listEntriesPaginated(id, page = 1, per_page = 50, sort = "key", order = "asc", query, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.watchlist/v2/watchlists/${id}/entries/paginated`, null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeEntries(id, arg1, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.watchlist/v2/watchlists/${id}/entries/remove`, arg1, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setDefaultTtl(id, seconds, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.watchlist/v2/watchlists/${id}/ttl/${seconds}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
